import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-pagination-v2-entity',
  templateUrl: './pagination-v2-entity.component.html',
  styleUrls: ['./pagination-v2-entity.component.css'],
})

export class PaginationV2EntityComponent implements OnInit, OnDestroy {
  @Input() showTotalObservable : boolean;
  @Input() agGridReference: AgGridAngular;
  @Input() totalRecords$ : Observable<any>;
  
  @Output() onMorePageClick = new EventEmitter<any>();
  
  
  private subs = new SubSink();

  rowPerPage = 10;
  currentPage: number;
  totalPage: BehaviorSubject<number>;
  totalRecords: BehaviorSubject<number>;

  getRowClass = params => {
    if (params.node.rowIndex % 2 === 1) {
      return 'ag-grid-odd-rows';
    }
    return '';
  }

  showMorePage: boolean = false;

  constructor() {
    this.currentPage = 1;
    this.totalPage = new BehaviorSubject<number>(1);
    this.totalRecords = new BehaviorSubject<number>(0);

  }

  ngOnInit() {

    if(this.showTotalObservable){
      this.subs.sink = this.totalRecords$.subscribe(t=>this.totalRecords.next(t) )
    }

    this.subs.sink = this.agGridReference.gridReady.pipe(
      map( () => this.agGridReference.api.paginationGetTotalPages()),
      map( b => b ? this.totalPage.next(b) : this.totalPage.next(1)),
      switchMap(() => this.agGridReference.paginationChanged.asObservable()),
      map( () => this.agGridReference.api.paginationGetTotalPages()),
    ).subscribe( resolve => {
      resolve ? this.totalPage.next(resolve) : this.totalPage.next(1);
    });
  }


  displayPage() {
    if (this.agGridReference.api) {
      this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
      this.totalPage.next(this.agGridReference.api.paginationGetTotalPages());
    }
    
    const startRow = this.totalPage.getValue() > 0 ? (1 + <number>((this.currentPage-1) * this.rowPerPage)):0;
    const endRow = this.currentPage * this.rowPerPage > this.totalRecords.getValue() ? this.totalRecords.getValue() : this.currentPage * this.rowPerPage;  

    return `${startRow} - ${endRow} of `;
  }

  onRowChange(row: number) {
    this.rowPerPage = row;
    this.agGridReference.api.paginationSetPageSize(row);
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
    if (row > 5) {
      this.agGridReference.api.setDomLayout('normal');
    } else {
      this.agGridReference.api.setDomLayout('autoHeight');
    }
  }

  firstPage() {
    this.agGridReference.api.paginationGoToFirstPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  previousPage() {
    this.agGridReference.api.paginationGoToPreviousPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  nextPage() {
    this.agGridReference.api.paginationGoToNextPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  showNextPage() {
    return this.totalRecords.getValue() > this.currentPage * this.rowPerPage;
  }

  lastPage() {
    this.agGridReference.api.paginationGoToLastPage();
    this.currentPage = this.agGridReference.api.paginationGetCurrentPage() + 1;
  }

  morePage() {
    this.onMorePageClick.emit();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
